module.exports = __webpack_public_path__ + "img/map-5.b89bc71e.jpg";